import { render, staticRenderFns } from "./SwitchButtonComponent.vue?vue&type=template&id=52890cb1&scoped=true"
import script from "./SwitchButtonComponent.vue?vue&type=script&lang=js"
export * from "./SwitchButtonComponent.vue?vue&type=script&lang=js"
import style0 from "./SwitchButtonComponent.vue?vue&type=style&index=0&id=52890cb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52890cb1",
  null
  
)

export default component.exports